/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
// import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
// import Meta from 'vue-meta'

// Routes
import store from '@/store'
import paths from './paths'
import User from '@/models/User'
// import { userInfo, networkInterfaces } from 'os' // @carlo: commented out
// import store from "@/store";

function route(path, view, name) {
  return {
    name: name || view,
    path,
    component: resolve => import('@/views/' + view + '.vue').then(resolve),
  }
}

Vue.use(Router)

// Create a new router
// @carlok: it does not support nested routing out of the box
const router = new Router({
  mode: 'history',
  routes: paths
    .map(path => route(path.path, path.view, path.name))
    .concat([
      {
        path: '*',
        redirect: '/login',
      },
    ]),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash,
      }
    }
    return {
      x: 0,
      y: 0,
    }
  },
})

router.beforeEach((to, from, next) => {
  // Logger.debug('router.beforeEach')

  const publicPaths = {
    '/login': true,
    '/registrationacknowledge': true,
    '/registration': true,
    // '/test': true,
  }

  // Logger.debug('ROUTER:', to.matched[0].path)
  const pathParametric = to.matched[0].path

  // if (Object.prototype.hasOwnProperty.call(privatePaths, 'pathParametric')) {
  if (!(pathParametric in publicPaths)) {
    // Logger.debug('MATCHED')
    // if (localStorage.getItem('authentication') !== null) {
    if (User.isLogged()) {
      next()
    } else {
      next({
        path: '/login',
      })
    }
  } else {
    next()
  }
})

// Vue.use(Meta)

export default router
